import { RenderSpec } from "./RenderSpec";
import { CopilotAvatar, CopilotThinking } from "./CopilotThinking";

function mdInline(text) {
  if (!text) return null;
  return text.split(/(\*\*.+?\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? (
      <strong key={i}>{part.slice(2, -2)}</strong>
    ) : (
      <span key={i}>{part}</span>
    )
  );
}

export function MessageList({ messages, bottomRef, onRefreshCached }) {
  return (
    <div className="cop-msg-list">
      {messages.map((m, i) => (
        <div key={i} className={`cop-msg cop-msg-${m.role}`}>
          {m.role === "assistant" && <CopilotAvatar />}
          <div className="cop-msg-bubble">
            {m.role === "user" ? (
              <p style={{ margin: 0 }}>{m.content}</p>
            ) : (
              <>
                {m.fromCache && (
                  <div className="cop-cache-badge-row">
                    <span className="cop-cache-badge">Respuesta reciente</span>
                    {onRefreshCached && (
                      <button
                        type="button"
                        className="cop-cache-refresh"
                        onClick={() => onRefreshCached(m, i)}
                      >
                        Actualizar
                      </button>
                    )}
                  </div>
                )}
                {m.content && !m.renderSpec?.blocks?.length && (
                  <div className="cop-msg-text">{mdInline(m.content)}</div>
                )}
                {m.streaming && !m.content && !m.renderSpec && <CopilotThinking />}
                {m.tools?.length > 0 && (
                  <div className="cop-tool-chips">
                    {m.tools.map((t, ti) => (
                      <span key={ti} className="cop-tool-chip">
                        {t.name}
                      </span>
                    ))}
                  </div>
                )}
                {m.renderSpec && <RenderSpec spec={m.renderSpec} />}
                {m.streaming && m.content && <span className="cop-cursor">▍</span>}
              </>
            )}
          </div>
        </div>
      ))}
      <div ref={bottomRef} className="cop-messages-anchor" aria-hidden="true" />
    </div>
  );
}
